import ApolloQuery from './ApolloQuery';

export default ApolloQuery;
